import { render } from "./EquipmentcategoriesIndex.vue?vue&type=template&id=d93d41b2&ts=true"
import script from "./EquipmentcategoriesIndex.vue?vue&type=script&lang=ts"
export * from "./EquipmentcategoriesIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__